import { z } from 'zod/v4'

export const WorkspaceValidatorApi = z.object({
  accountId: z.string(),
  backgroundImage: z.string(),
  createdAt: z.string(),
  id: z.string(),
  name: z.string(),
  status: z.enum(['active', 'archived']),
  locationCount: z.number().optional(),
  connectionCount: z.number().optional(),
  gridCount: z.number().optional(),
  campaignCount: z.number().optional(),
  landingPageCount: z.number().optional(),
})

export const WritableWorkspaceValidatorApi = WorkspaceValidatorApi.omit({
  id: true,
  createdAt: true,
}).partial()

export type WorkspaceApi = z.infer<typeof WorkspaceValidatorApi>
export type WritableWorkspaceApi = z.infer<typeof WritableWorkspaceValidatorApi>

export const WorkspacePermissionValidatorApi = z.object({
  id: z.string(),
  workspaceId: z.string(),
  userId: z.string(),
  role: z.union([z.literal('owner'), z.literal('editor'), z.literal('viewer')]),
  createdAt: z.string(),
})

export const WritableWorkspacePermissionValidatorApi = WorkspacePermissionValidatorApi.omit({
  id: true,
  createdAt: true,
  workspaceId: true,
})

export type WorkspacePermissionApi = z.infer<typeof WorkspacePermissionValidatorApi>
export type WritableWorkspacePermissionApi = z.infer<typeof WritableWorkspacePermissionValidatorApi>

export const GridValidatorApi = z.object({
  name: z.string(),
  id: z.string(),
  households: z.number(),
  targetedHouseholds: z.number(),
  targetingType: z.enum(['radius', 'zip code', 'county']),
  filterCount: z.number().optional(),
  createdAt: z.string(),
  workspaceId: z.string(),
})

export const WritableGridValidatorApi = GridValidatorApi.omit({
  id: true,
  createdAt: true,
  workspaceId: true,
})

export type GridApi = z.infer<typeof GridValidatorApi>
export type WritableGridApi = z.infer<typeof WritableGridValidatorApi>
